// The action a guest tried before an auth gate (useAuthGate), resumed by the
// page it came from once they are signed in. One intent at a time: a newer
// gate replaces it, closing the gate clears it, and it expires after 10 min.
export const PENDING_INTENT_KEY = 'aluvo_pending_intent';
export const PENDING_INTENT_TTL_MS = 10 * 60 * 1000;

/** Store `intent`. Pass `expiresAt` to keep an earlier deadline (never extend it). */
export function savePendingIntent(intent, { expiresAt } = {}) {
    try {
        sessionStorage.setItem(PENDING_INTENT_KEY, JSON.stringify({
            ...intent,
            expiresAt: expiresAt ?? Date.now() + PENDING_INTENT_TTL_MS,
        }));
    } catch { /* storage unavailable: the gate still works, nothing resumes */ }
}

export function clearPendingIntent() {
    try { sessionStorage.removeItem(PENDING_INTENT_KEY); } catch { /* ignore */ }
}

/** The stored intent, or null. Expired or unreadable intents are cleared. */
export function readPendingIntent() {
    try {
        const raw = sessionStorage.getItem(PENDING_INTENT_KEY);
        if (!raw) return null;
        const intent = JSON.parse(raw);
        if (!intent || (intent.expiresAt && intent.expiresAt < Date.now())) {
            clearPendingIntent();
            return null;
        }
        return intent;
    } catch {
        clearPendingIntent();
        return null;
    }
}

/** Where to send someone after a detour (DOB, onboarding): the gated page, if any. */
export function pendingIntentReturnUrl() {
    const url = readPendingIntent()?.returnUrl;
    return typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') ? url : null;
}
